<template>
  <div class="d-flex flex-column min-vh-100 bg-light">
    <AdminHeaderComponent />
    <div class="flex-grow-1 container-fluid">
      <div v-if="loadingErrorMessage">
        <h3  class="text-center mt-5">
          <div class="mb-3">Oups!</div>
          {{ loadingErrorMessage }}
        </h3>
      </div>
      <div v-else-if="!loading">
        <div v-if="props.title || $slots.actions" class="mb-3 d-flex">
          <div class="col align-self-center">
            <button v-if="props.showBackButton"
              class="btn btn-outline-secondary text-nowrap"
              @click="$router.back()"
            >
              <i class="fa-solid fa-arrow-left pe-2"></i> Retour
            </button>
          </div>
          <h2 v-if="props.title" class="m-0 text-uppercase d-none d-md-block">{{ props.title }}</h2>
          <div class="col text-end align-self-center">
            <slot name="actions"></slot>
          </div>
        </div>
        <h2 v-if="props.title" class="m-0 text-uppercase d-md-none text-center">{{ props.title }}</h2>
        <div v-if="$slots.stickyMenu" class="sticky-top bg-light py-2" style="--bs-bg-opacity: 0.9;">
          <slot name="stickyMenu"></slot>
        </div>
        <slot></slot>
        <div v-if="$slots.actions" class="row my-3">
          <div class="col text-end" v-if="!actionsOnlyOnTop">
            <slot name="actions"></slot>
          </div>
        </div>
      </div>
      <div v-else class="text-center mt-5">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Chargement en cours...</span>
        </div>
        <div>Chargement en cours...</div>
      </div>
    </div>
    <FooterComponent />
    <Transition name="fade">
      <button
        v-if="showScrollTop"
        class="btn btn-primary position-fixed bottom-0 start-0 mb-4 ms-2 ms-md-4 p-0 rounded-circle shadow d-flex align-items-center justify-content-center z-3 scroll-top-btn"
        @click="scrollToTop"
        aria-label="Retour en haut"
      >
        <i class="fa-solid fa-chevron-up"></i>
      </button>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import FooterComponent from '@/components/FooterComponent.vue'
import AdminHeaderComponent from '@/components/admin/AdminHeaderComponent.vue'

const props = withDefaults(defineProps<{
  title?: string,
  loading?: boolean,
  loadingErrorMessage?: string
  showBackButton?: boolean,
  actionsOnlyOnTop?: boolean
}>(), {
  showBackButton: true,
  actionsOnlyOnTop: false
})

const showScrollTop = ref(false)

const onScroll = () => {
  showScrollTop.value = window.scrollY > 300
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<style scoped>
.scroll-top-btn {
  width: 48px;
  height: 48px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
